
<div class="container page-content"><br>
			
    <app-product-list></app-product-list>   

  
    

</div>